export interface EstimatedTimesResponse {
  estimatedTime: {
    waiver: number;
    start: number;
    rundown: number;
    news: number;
    rankings: number;
    rosters: number;
    chatbot: number;
  };
}

export const getEstimatedTimes = async (accessAuthToken: string): Promise<EstimatedTimesResponse> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/rotogpt/estimated_times`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to get estimated times");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting estimated times:", error);
    // Return default values as fallback
    // return {
    //   estimatedTime: {
    //     waiver: 90000,
    //     start: 90000,
    //     rundown: 90000,
    //     news: 13200,
    //     rankings: 13200,
    //     rosters: 13200,
    //   },
    // };
  }
};
